var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"content"},[(_vm.data.length)?_c('v-chart',{attrs:{"option":_vm.option}}):[_c('div',{staticClass:"i-chart-empty"}),_c('div',{staticClass:"placeholder"},[_vm._v("数据同步中…")])]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }